import {Client} from "@/endpoints/rutsolve/gql/resolvers/client"
import {
    Order as OrderModel,
    CreateOrderMutationVariables,
    CreateOrderDocument,
    UpdateOrderDocument,
    UpdateOrderMutationVariables,
    OrderInput,
    OrderResponse,
    OrderSelectorDocument,
    OrderSelectorQueryVariables,
    OrderSummaryDocument,
    OrderSummaryQueryVariables,
    RemoveOrderMutationVariables,
    RemoveOrderDocument,
    OrderDocument,
    OrderQueryVariables,
    NewOrderNumberDocument,
    NewOrderNumberQueryVariables
} from "@/endpoints/rutsolve/gql/generated/graphql"

export class Order extends Client {
    constructor() {
        super()
    }

    public async create(input: OrderModel): Promise<OrderModel> {
        try {
            const variables: CreateOrderMutationVariables = {
                input: {
                    billedAt: this.date(input.billedAt),
                    currency: input.currency,
                    discountType: input.discountType,
                    discountValue: this.decimal(input.discountValue),
                    memorandum: input.memorandum,
                    number: input.number,
                    reference: input.reference,
                    relationID: input.relationID,
                    relationType: input.relationType,
                    shiftedVAT: input.shiftedVAT,
                    status: input.status,
                    type: input.type
                }
            }
            const response = await this.client.request(CreateOrderDocument, variables)
            return response.createOrder
        } catch (error) {
            this.handleError(error)
        }
    }

    public async summary(orderID: string): Promise<OrderModel> {
        try {
            const variables: OrderSummaryQueryVariables = {
                id: orderID,
            }
            const response = await this.client.request(OrderSummaryDocument, variables)
            return response.order
        } catch (error) {
            this.handleError(error)
        }
    }

    public async order(orderID: string): Promise<OrderModel> {
        try {
            const variables: OrderQueryVariables = {
                id: orderID,
            }
            const response = await this.client.request(OrderDocument, variables)
            return response.order
        } catch (error) {
            this.handleError(error)
        }
    }

    public async newNumber(orderType: string): Promise<number> {
        try {
            const variables: NewOrderNumberQueryVariables = {
                input: orderType,
            }
            const response = await this.client.request(NewOrderNumberDocument, variables)
            return response.newOrderNumber
        } catch (error) {
            this.handleError(error)
        }
    }

    public async selector(input?: OrderInput): Promise<OrderResponse> {
        try {
            const variables: OrderSelectorQueryVariables = {
                input: input
            }
            const response = await this.client.request(OrderSelectorDocument, variables)
            return response.orders
        } catch (error) {
            this.handleError(error)
        }
    }

    public async update(input: OrderModel) {
        try {
            const variables: UpdateOrderMutationVariables = {
                input: {
                    billedAt: this.date(input.billedAt),
                    currency: input.currency,
                    discountType: input.discountType,
                    discountValue: this.decimal(input.discountValue),
                    id: input.id,
                    memorandum: input.memorandum,
                    number: input.number,
                    reference: input.reference,
                    shiftedVAT: input.shiftedVAT,
                    status: input.status,
                    type: input.type
                }
            }
            await this.client.request(UpdateOrderDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }

    public async remove(orderID: string) {
        try {
            const variables: RemoveOrderMutationVariables = {
                orderID: orderID
            }
            await this.client.request(RemoveOrderDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }
}
